import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, PhoneIcon, MapPinIcon, ClockIcon } from 'lucide-react';
export function CTASection() {
  return <section id="contacto" className="relative py-24 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-18">
      {/* Background with gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-delux-alt to-delux-bg z-0" data-id="element-19"></div>

      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-delux-gold to-transparent opacity-30" data-id="element-20"></div>
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-delux-gold to-transparent opacity-30" data-id="element-21"></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-23">
          <ZapIcon className="w-12 h-12 text-delux-gold mx-auto mb-8" data-id="element-24" />

          <h2 className="font-heading text-4xl md:text-5xl text-delux-white mb-8 leading-tight" data-id="element-25">
            Tu Mejor Versión Está A{' '}
            <span className="text-delux-gold" data-id="element-26">Una Cita De Distancia</span>
          </h2>

          <div className="font-body text-lg text-delux-body space-y-6 mb-12 max-w-3xl mx-auto" data-id="element-27">
            <p data-id="element-28">
              Los hombres que admiras — los que parecen moverse con confianza
              silenciosa, que se ven impecables sin esforzarse demasiado, que
              entran a los cuartos y cambian la energía — no llegaron ahí por
              accidente.
            </p>
            <p data-id="element-29">
              Encontraron al barbero correcto. Se comprometieron con su imagen.
              Dejaron de conformarse.
            </p>
            <p className="text-xl text-delux-white font-medium" data-id="element-30">
              Hoy es el día en que tú también dejas de conformarte.
            </p>
          </div>

          <div className="bg-delux-card border border-delux-gold/30 rounded-xl p-8 md:p-12 shadow-[0_0_30px_rgba(200,164,90,0.1)]" data-id="element-31">
            <h3 className="font-heading text-2xl md:text-3xl text-delux-gold font-bold mb-8 uppercase tracking-wider" data-id="element-32">
              Reserva Tu Experiencia Barbershop Delux Cut Ahora
            </h3>

            <div className="flex flex-col space-y-6 mb-10 text-left max-w-2xl mx-auto" data-id="element-33">
              <a href="tel:7866516944" className="flex items-center group" data-id="element-34">
                <div className="w-12 h-12 rounded-full bg-delux-gold/10 flex items-center justify-center mr-4 group-hover:bg-delux-gold/20 transition-colors" data-id="element-35">
                  <PhoneIcon className="w-6 h-6 text-delux-gold" data-id="element-36" />
                </div>
                <span className="font-body text-lg text-delux-white group-hover:text-delux-gold transition-colors" data-id="element-37">
                  Llama o Escribe: (786) 651-6944
                </span>
              </a>

              <div className="flex items-center" data-id="element-38">
                <div className="w-12 h-12 rounded-full bg-delux-gold/10 flex items-center justify-center mr-4" data-id="element-39">
                  <MapPinIcon className="w-6 h-6 text-delux-gold" data-id="element-40" />
                </div>
                <span className="font-body text-lg text-delux-white" data-id="element-41">
                  Encuéntranos En: Sunshine Plaza — 1145 Homestead Rd N, Lehigh
                  Acres, FL 33936
                </span>
              </div>

              <div className="flex items-center" data-id="element-42">
                <div className="w-12 h-12 rounded-full bg-delux-gold/10 flex items-center justify-center mr-4" data-id="element-43">
                  <ClockIcon className="w-6 h-6 text-delux-gold" data-id="element-44" />
                </div>
                <span className="font-body text-lg text-delux-white" data-id="element-45">
                  Abiertos Hasta Las 7 PM — Se Aceptan Sin Cita Previa
                </span>
              </div>
            </div>

            <a href="tel:7866516944" className="inline-block bg-delux-gold hover:bg-delux-gold-light text-delux-bg px-10 py-5 rounded font-heading font-bold text-xl tracking-wider transition-all duration-300 hover:shadow-[0_0_25px_rgba(200,164,90,0.6)] transform hover:-translate-y-1 w-full md:w-auto" data-id="element-46">
              Llamar Ahora: (786) 651-6944
            </a>

            <p className="font-heading text-delux-body italic mt-8 text-lg" data-id="element-47">
              Tu mejor versión empieza aquí. Ven a visitarnos.
              <br data-id="element-48" />
              <span className="text-delux-gold" data-id="element-49">
                — El Equipo Barbershop Delux Cut
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}